import {Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Mixture} from "../../data/mixtures";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MixtureService} from "../../services/mixture.service";
import {InputModule} from "../../modules/input/input.module";

import {ProductTableComponent} from "../../components/product-table/product-table.component";
import {ActivatedRoute} from "@angular/router";
import {SliderComponent} from "../../modules/input/slider/slider.component";
import {NgOptimizedImage} from "@angular/common";

@Component({
    selector: 'app-pressure',
  imports: [
    ReactiveFormsModule,
    InputModule,
    ProductTableComponent,
    NgOptimizedImage,
    NgOptimizedImage
  ],
    templateUrl: './pressure.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './pressure.page.scss'
})
export class PressurePage implements OnInit {
  matchingProducts: Mixture[] = []
  similarProducts: Mixture[] = []
  @ViewChild('numberInput') numberInput?: ElementRef<HTMLInputElement>
  @ViewChild(SliderComponent) slider?: SliderComponent

  form = new FormGroup({
    pressure: new FormControl(1.2)
  })
  pressure: number = 1.2;

  constructor(private mixtureService: MixtureService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.loadBarFromURLFragment(this.activatedRoute.snapshot.fragment)
    this.findProducts()

    this.activatedRoute.fragment.subscribe((fragment) => {
      this.loadBarFromURLFragment(fragment)
      this.findProducts()
    })

    this.form.valueChanges.subscribe((value) => {
      this.numberInput!.nativeElement.value = String(value.pressure)
    })
  }

  changeSlider(pressure: number) {
    this.form.controls.pressure.patchValue(pressure)

    this.findProducts()
  }

  changeInput(e: Event) {
    const input = e.target as HTMLInputElement

    let pressure = parseFloat(input.value)

    if (pressure > 7.8) {
      pressure = 7.8
    } else if (pressure < 1.2) {
      pressure = 1.2
    }

    input.value = pressure.toFixed(1)

    this.form.controls.pressure.patchValue(pressure)
    this.slider?.setValue(pressure)

    this.findProducts()
  }

  findProducts() {
    const pressure = this.form.value.pressure!

    const {matchingProducts, similarProducts} = this.mixtureService.findProductsForPressure(pressure)

    this.matchingProducts = matchingProducts
    this.similarProducts = similarProducts
  }

  private loadBarFromURLFragment(fragment: string | null) {
    if (fragment === null) {
      return
    }

    if (!/^bar-[0-9.]+$/.test(fragment)) {
      return
    }

    const [_unused, pressure] = fragment.split('-')

    setTimeout(() => {
      this.pressure = Number(pressure)
      this.form.patchValue({pressure: this.pressure})
      this.slider?.setValue(this.pressure)
      this.findProducts()
    })
  }
}
